import { useState } from 'react'
import { Navbar, Welcome, Footer, Services, Transactions } from './components'
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import './App.css'

const App = () => {
  const [count, setCount] = useState(0)
  return (
    <div className="min-h-screen">
      <div className="gradient-bg-welcome">
        <ToastContainer
          draggable={false}
           
          autoClose={8000}
        />
      <Navbar/>
      <Welcome/>
      
      </div>
      
      {/* <Services/> */}
      <Transactions/>
      <Footer/>

    </div>
  )
}

export default App
 